import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import Login from './views/Login.vue'
import Politica from './views/Politica.vue'
import PreInscricao from './views/Pre-Inscricao.vue'
import PreInscricaoOld from './views/Pre-Inscricao-Old.vue'
import Obrigado from './views/Obrigado.vue'
import FinalizarInscricao from './views/Finalizar-Inscricao.vue'
import Processando from './views/Processando.vue'
import Admin from './views/Admin.vue'
import CC1 from './views/CC1.vue'
import CC2 from './views/CC2.vue'
import CC3 from './views/CC3.vue'
import firebase from 'firebase'
import store from './store/index'

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/como-tratar-doenças-reumatológicas-com-canabidiol',
      name: 'cc1',
      component: CC1,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/atualizacao-do-uso-do-canabidiol-e-derivados-na-medicina-e-esporte',
      name: 'cc2',
      component: CC2,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cannabis-aplicada-a-reumatologia',
      name: 'cc3',
      component: CC3,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: '/politica-de-privacidade',
      name: 'politica',
      component: Politica
    },
    {
      path: '/pre-inscricao',
      name: 'pre-inscricao',
      component: PreInscricao
    },
    {
      path: '/pre-inscricao-old',
      name: 'pre-inscricao-old',
      component: PreInscricaoOld
    },
    {
      path: '/obrigado',
      name: 'obrigado',
      component: Obrigado
    },
    {
      path: '/finalizar-inscricao',
      name: 'finalizar-inscricao',
      component: FinalizarInscricao
    },
    {
      path: '/processando',
      name: 'processando',
      component: Processando
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})

// firebase.auth().onAuthStateChanged((user) => {
// 	// console.log("On Auth State Changed")
//     if (!user) {
//       // console.log("No user - go to login");
//       router.replace('/login');
//     } else{
//       // console.log("Session started as -> "+user.email);
//     }
// });

router.beforeEach((to, from, next) => {

  let requiresAuth = to.matched.some(rec => rec.meta.requiresAuth);
  let requiresAdmin = to.matched.some(rec => rec.meta.requiresAdmin);
  // let t

  let user = store.getters.getUser
  let isAdmin = store.getters.getAdminToken
  // let user2 = store.getters.getUserData
  // console.log(user)
  // console.log(user2)
  // console.log(isAdmin)

  if(requiresAuth && !user) {
    next('/login')
    console.log("aqui")
  } else if(requiresAuth && !requiresAdmin && user) {
    next()
  } else if(requiresAdmin && user) {
    isAdmin ? next() : next('/')
  } else {
    next()
  }
});

export default router
